export default {
    getDocumentTypes: { method: 'get', url: 'signatures/document-types' },
    postDocumentTypes: { method: 'post', url: 'signatures/document-types' },
    putDocumentTypes: { method: 'put', url: 'signatures/document-types/{id}' },
    deleteDocumentTypes: { method: 'delete', url: 'signatures/document-types/{id}' },
}
